import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import classnames from 'classnames'
import Router from 'next/router'
import BackCircle from '../../components/svg/back-circle'
import useDebouncedCallback from '../../hooks/use-debounced-callback'

export default function Navbar({ nodesToObserve }) {
  const [activeAnchorId, setActiveAnchorId] = useState(null)
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' })

  const handleAnchorClick = (ref) => (event) => {
    event.preventDefault()
    ref.scrollIntoView(true)
    setActiveAnchorId(ref.id)
  }

  useEffect(() => {
    const { hash } = window.location
    if (hash) setActiveAnchorId(hash.slice(1))
  }, [])

  const debouncedScrollListener = useDebouncedCallback(
    () => {
      for (const { ref } of Object.values(nodesToObserve.current)) {
        if (ref && ref.getBoundingClientRect().top < 300) setActiveAnchorId(ref.id)
      }
    },
    300,
    [nodesToObserve],
  )

  useEffect(() => {
    if (isMobile) return

    document.addEventListener('scroll', debouncedScrollListener)

    return () => document.removeEventListener('scroll', debouncedScrollListener)
  }, [debouncedScrollListener, isMobile])

  return (
    <nav className='navbar'>
      <div className='navWrapper flex alignCenter'>
        <div className='backToListings flex alignCenter'>
          <button
            className='flatBtn backBtn flex'
            onClick={Router.back}
            aria-label='Back to Listings'
          >
            <BackCircle />
            <span>Back to Listings</span>
          </button>
        </div>
        <div className='linkWrapper flex justifyCenter'>
          {Object.values(nodesToObserve.current).map(({ displayName, ref }) => (
            <a
              key={ref?.id}
              className={classnames({ active: activeAnchorId === ref?.id })}
              onClick={handleAnchorClick(ref)}
            >
              {displayName}
            </a>
          ))}
        </div>
      </div>

      <style jsx>{`
        .navWrapper {
          max-width: 194rem;
          width: 100%;
          height: 100%;
          margin: 0 auto;
          padding: 0 4.2rem;
        }

        .navbar {
          position: sticky;
          top: 0;
          width: 100%;
          height: 9.4rem;
          border-bottom: 1px solid #47648f;
          background: var(--secondary-bg-color);
          z-index: 10;

          a + a {
            margin: 0 0 0 5.8rem;
          }
        }

        .linkWrapper a {
          color: var(--primary-text-color);
          cursor: pointer;
          font-size: 1.8rem;
          font-weight: 700;

          &.active {
            color: var(--primary-color);
          }
        }

        .linkWrapper {
          width: 100%;
        }

        .backToListings {
          position: absolute;

          .backBtn {
            font-size: 1.8rem;
            color: var(--secondary-text-color);

            span {
              margin: 0 0 0 1rem;
            }
          }
        }

        @media (min-width: 1025px) and (max-width: 1364px) {
          .linkWrapper {
            max-width: calc(100% - 33rem);
          }

          .backBtn span {
            display: none;
          }
        }
      `}</style>
    </nav>
  )
}
